import React from "react";
import { Card, LinkButton, Title, Typography, useI18nContext } from "@procore/core-react";
import type { TmsSupportedLocale } from "@procore/globalization-toolkit";
import { generateSupportDocsURL, TMS_SUPPORTED_LOCALES } from "@procore/globalization-toolkit";

export const SUPPORT_DOCS_URL =
   "https://support.procore.com/products/online/user-guide/company-level/resource-planning";

const isTmsSupportedLocale = (locale: string): locale is TmsSupportedLocale =>
   TMS_SUPPORTED_LOCALES.some((supportedLocale) => supportedLocale === locale);

export const SupportCenterCard = () => {
   const I18n = useI18nContext();
   const locale: TmsSupportedLocale = isTmsSupportedLocale(I18n.locale) ? I18n.locale : "en";

   return (
      <Card
         style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "0.5rem",
            padding: "1rem",
            alignSelf: "stretch",
            borderRadius: "0.5rem",
         }}
      >
         <Title style={{ alignSelf: "stretch" }}>
            <Title.Text>
               <Typography intent="h2" as="h2">
                  {I18n.t("views.company.workforce_planning.home.support_center.title")}
               </Typography>
            </Title.Text>
            <Title.Subtext>
               {I18n.t("views.company.workforce_planning.home.support_center.description")}
            </Title.Subtext>
            <Title.Actions>
               <LinkButton
                  target="_blank"
                  variant="secondary"
                  href={generateSupportDocsURL(SUPPORT_DOCS_URL, locale)}
               >
                  {I18n.t("views.company.workforce_planning.home.support_center.link_text")}
               </LinkButton>
            </Title.Actions>
         </Title>
      </Card>
   );
};
